/*eslint no-sequences: "off"*/
/*eslint no-empty-pattern: "off"*/

import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IModalContext, IModalContentTypes } from './interfaces';
import { initState } from './init.state';


export interface OpenModalPayload {
  content: IModalContentTypes;
  props?: any;
  type?: string;
  visible?: boolean;
  show?: boolean;
}

export interface OpenInlineBrowserPayload {
  url: string;
  file_base64: string|null;
  title?: string;
}

export const ModalContextSlice = createSlice({
  name: 'modalContext',
  initialState: initState,
  reducers: {
    OpenModal: (state: IModalContext, action: PayloadAction<OpenModalPayload>) => {
      return {
        ...state,
        open: true,
        content: action.payload.content,
        props: action.payload.props
      };
    },

    CloseModal: (state: IModalContext) => {
      return {
        ...state,
        open: false,
        content: 'BASIC' as IModalContentTypes,
        props: undefined
      };
    },

    OpenInlineBrowser: (state: IModalContext, action: PayloadAction<OpenInlineBrowserPayload>) => {

      return {
        ...state,
        inlineBrowserOpen: true,
        inlineBrowser: {
          file_base64: action.payload.file_base64,
          url: action.payload.url,
          title: action.payload.title,
        },
      };
    },

    CloseInlineBrowser: (state: IModalContext) => {
      return {
        ...state,
        inlineBrowserOpen: false,
        inlineBrowser: undefined,
      };
    },
  },
});

// Action creators are generated for each case reducer function
export const { OpenModal, CloseModal, OpenInlineBrowser, CloseInlineBrowser } = ModalContextSlice.actions;

export default ModalContextSlice.reducer;
